import type { ComponentProps } from 'react';
import { Modal } from 'is24-corecss';
import { styles } from './styles';
import { useSlots } from './SlotContext';

export const Header = ({ className = '', ...props }: Omit<ComponentProps<typeof Modal.Header>, 'id'>) => {
  const { headerId } = useSlots();
  return <Modal.Header {...props} id={headerId} className={`${styles.fixedSection} ${className}`} />;
};
